import React from 'react'

const Popover = ({ popoverTitle, popoverBody }) => {

        return (
        <div className='pop d-none d-md-block'>
            <h3 className='pop-title'>{popoverTitle}</h3>
            <p className='pop-body'>{popoverBody}</p>
        </div>
    )       
   
}

export default Popover
